<template>
    <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-200">
            <tr>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Loại xe 2
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Mô tả
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Trạng thái
                </th>
                <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ghi chú
                </th>
                <th
                    scope="col"
                    class="px-6 relative py-3">
                    <span class="sr-only">
                        Edit
                    </span>
                </th>
            </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
            <tr
                v-for="person in people"
                :key="person.id">
                <td class="px-6 py-4 text-sm font-medium text-gray-900">
                    {{ person.name }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    {{ person.title }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500">
                    <hts-form-badges
                        v-if="person.status"
                        size="small"
                        color="success">
                        Active
                    </hts-form-badges>

                    <hts-form-badges
                        v-if="!person.status"
                        size="small"
                        color="disable">
                        Block
                    </hts-form-badges>
                </td>
                <td class="px-6 py-4 text-sm text-gray-500 w-72">
                    ........
                </td>
                <td class="px-6 py-4 text-right text-sm font-medium">
                    <hts-form-button
                        type="text"
                        color="info">
                        Edit
                    </hts-form-button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import listMembers from '@/data/members/listMembers.json'
const people = ref(listMembers)
</script>
